module.exports = __webpack_public_path__ + "img/content-1.2f976690.png";